import React, { useEffect, useState } from "react";
import CTooltip from "react-tooltip-lite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Bar } from "react-chartjs-2";
import { shuffle } from "lodash";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from "components/ErrorBoundary";
import DownloadCSVButton from "./DownloadCsv";
// import Download from "../../../../assets/icon/Download - Icon 3.svg";
// import DownloadCSVButton from "pages/Dashboard/DownlaodCSV";

const TopDrugs = (props) => {
  const { top10Drugs, } = props;

  const data = top10Drugs;

  const [active, setActive] = useState("6");
  const names = [];
  const ammountcount = [];
  const RxCount = [];
  const NDC = [];

  let maxValue = Math.max.apply(
    null,
    data?.map(function (o) {
      return o.value;
    })
  );
  data?.forEach(({ name, display }) => {
    names?.push(name);
    ammountcount.push(display.replace(/[^0-9.-]+/g, ""));
  });

  data?.forEach(({ count }) => {
    RxCount.push(count);
  });
  data?.forEach(({ labelToolTip }) => {
    NDC.push(labelToolTip);
  });

  ammountcount, "amountcount";

  const chartData = {
    maintainAspectRatio: false,
    labels: data?.map(({ name, labelToolTip }) => [name, "NDC:" + labelToolTip]),
    datasets: [
      {
        label: 'Net Savings',
        data: data?.map(({ value }) => value),
        borderColor: '#702c62',
        backgroundColor: '#702c62',
        barPercentage: 0.4,
        pointRadius: 2.5,
        tension: 0.3,
        fill: false,
      },
    ],
  };


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    // maintainAspectRatio: true,
    indexAxis: "y",
    scales: {
      x: {
        ticks: {
          color: "#212121",
          callback: function (value, index, ticks) {
            return value;
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: "#212121",
        },
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          //   title: function (item) {
          //     const { name, count } = data[item[0].dataIndex];
          //     return `${name}\nTotal Claim Count : ${count}`;
          //   },
          title: function (item) {
            const { name, count } = data[item[0].dataIndex];
            return `${name}\nRx Count ${count}`;
          },

          label: function (d, t) {
            var xLabel = d.dataset.label;
            var yLabel =
              "$" +
              Number(d.formattedValue.replace(/[^0-9.-]+/g, ""))
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return xLabel + ": " + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? "end"
            : "start";
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? "black"
            : "black";
        },
        anchor: function (context) {
          return context.dataset.data[context.dataIndex] < maxValue / 2
            ? "end"
            : "center";
        },
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 5 },
          value: {
            color: "#2B3346",
          },
        },
        formatter: function (value) {
          return (
            "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
          );
        },
      },
    },
  };

  const handleActive = (title) => {
    if (active === title) return;
    const shuffleArry = shuffle(data);
    setActive(title);
    setData(shuffleArry);
  };

  const getDate = () => {
    setActive("custom");
  };

  return (
    <ErrorBoundary>
      <Card className="p-3 h-100 shadow-top">
        <CardHeader className="border-0 bg-white px-0">
          <Row className="align-items-center">
            <Col>
              <CTooltip
                content={
                  <div className="tip-list-info" style={{ width: "300px" }}>
                    <p>
                      Top 10 drugs with the highest net savings based on the selected covered entity, pharmacy, date range.
                    </p>
                  </div>
                }
              >
                <CardTitle className="f-20 font-weight-600 dashboard-headings">
                  <div className="d-flex justify-content-between align-items-center top_left_hed pb-1 graph-headings">
                    Top 10 Performing Drugs
                    <DownloadCSVButton
                      monthsdata={NDC}
                      valuedata1={names}
                      valuedata2={RxCount}
                      valuedata3={ammountcount}
                      heading1={["NDC", "Drug Name", "Rx Count", "Net Savings"]}
                      filenamedata={"Top_10_Performing_Drugs"}
                    />
                    {/* <img src={Download} /> */}
                  </div>
                </CardTitle>
              </CTooltip>
            </Col>
            <Col xs="auto">
              <Nav className="widget-tabs"></Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="dashboard-chart-body p-0">
          <div className="dashboard-chart-height chat-container">
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default TopDrugs;
